import "../../App.css";
import React, { lazy, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import { Route, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CommonRoutes from "../Common/commonRoute";
import { setInitialState } from "../../Action/authAction";
import { useDispatch } from "react-redux";

import {
  ItTeamPanelEmpSidebarData,
  ItTeamPanelSidebarData,
} from "../../Module/itTeamPanelSidebarData";

// Movements of Meeting (same pages as the other panels)
const MovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
const VideoDownloaded = lazy(() =>
  import("../CXOPanel/VideoDownloaded/VideoDownloaded")
);
const PaidPageAnalysis = lazy(() => import("../CXOPanel/paidPageAnalysis"));

function ItTeamDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    authToken: state?.Auth?.authToken,
    role: state?.Auth?.userInfo?.role,
  }));

  useEffect(() => {
    if (!(role === "ITTEAM" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, authToken, navigate]);

  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2 ? ItTeamPanelEmpSidebarData : ItTeamPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <CommonRoutes loginType={loginType} defaultPage={<VideoDownloaded />}>
            <Route path="videoDownloaded" element={<VideoDownloaded />} />
            <Route path="paidPageAnalysis" element={<PaidPageAnalysis />} />
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route path="editMovementsOfMeeting" element={<EditMovementsOfMeeting />} />
          </CommonRoutes>
        }
      </div>
    </div>
  );
}

export default ItTeamDashboard;
